<template>
  <div class="my-orders-page">
    <h2 class="page-title">Мої замовлення</h2>
    <p v-if="actionError" role="alert" class="order-action-error">{{ actionError }}</p>
    <p v-if="actionMessage" role="status">{{ actionMessage }}</p>
    <div v-if="orders && orders.length > 0" class="orders-list">
      <div v-for="order in orders" :key="order.id" style="margin-bottom: 24px;">
        <div class="order-card" :id="`order-${order.id}`">
          <div
            class="order-images-wrapper"
            :class="
              `images-count-${Math.min(filteredOrderItems(order).length, 4)}`
            "
          >
            <img
              v-for="(item, idx) in (filteredOrderItems(order) || []).slice(0, 4)"
              :key="idx"
              :src="item.product.img"
              alt="product"
              class="order-image"
            />
          </div>
          <div class="order-info">
            <div class="order-row">
              <span class="order-label">Номер замовлення</span>
              <span class="order-value order-number">#{{ order.id }}</span>
            </div>
            <div class="order-row">
              <span class="order-label">Дата оформлення</span>
              <span class="order-value order-date">
                {{ formatOrderDate(order) }}
              </span>
            </div>
            <div class="order-row">
              <span class="order-label">Сума замовлення</span>
              <span class="order-value order-amount"
                >{{ order.sum_total | money }}</span
              >
            </div>
            <div class="order-row details-row">
              <a
                href="#"
                class="order-details"
                @click.prevent="toggleOrder(order.id)"
              >
                Деталі замовлення
                <img src="@/assets/arrow.svg" alt="arrow" class="arrow-down" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="openedOrderId === order.id" class="order-products-list">
          <div
            v-for="(item, i) in filteredOrderItems(order)"
            :key="i"
            class="order-product"
          >
            <img :src="item.product.img" class="order-product-image" />
            <div class="order-product-info">
              <div class="order-product-name">{{ item.product.name }}</div>
              <div class="order-product-code">Код: {{ item.product.id }}</div>
              <div class="order-product-wrapper">
                <div class="order-product-price">
                  {{ (item.price != null ? item.price : item.product.price) | money }}
                </div>
                <div class="order-product-qty">x{{ item.qty }}</div>
              </div>
            </div>
            <button
              class="order-product-cart-btn"
              :disabled="busy || item.product.available === false || Number(item.product.qty) < 1"
              :aria-label="`У кошик: ${item.product.name}`"
              @click="setAddproductToCart(item)"
            >
              <img
                src="@/assets/shopping_cart.svg"
                alt="cart"
                class="order-product-cart-icon"
              />
            </button>
          </div>
          <p>Статус: {{ order.status }}</p>
          <p v-if="order.ttn">ТТН: {{ order.ttn }}</p>
          <a v-if="order.tracking_url" :href="order.tracking_url" target="_blank" rel="noopener" class="order-link">Відстежити посилку</a>
          <a v-if="order.support_url" :href="order.support_url" target="_blank" rel="noopener" class="order-link">Допомога із замовленням</a>
          <div class="order-total">
            <p class="order-total-text">Всього</p>
            <p class="order-total-price">{{ order.sum_total | money }}</p>
          </div>
          <button class="repeat-order-btn" :disabled="busy || $store.getters.repeatPending" @click="repeatOrder(order)">
            <img src="@/assets/shopping_cart.svg" class="repeat-order-icon" />
            Повторити замовлення
          </button>
        </div>
      </div>
    </div>
    <div v-else class="orders-empty-state">
      <svg
        class="orders-empty-illustration"
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="70" cy="70" r="70" fill="#E8F7F9" />
        <rect
          x="40"
          y="44"
          width="60"
          height="56"
          rx="8"
          fill="#fff"
          stroke="#16ABB8"
          stroke-width="4"
        />
        <path
          d="M40 58h60"
          stroke="#16ABB8"
          stroke-width="4"
          stroke-linecap="round"
        />
        <path
          d="M54 72h32M54 84h20"
          stroke="#9FE0E7"
          stroke-width="4"
          stroke-linecap="round"
        />
        <circle cx="100" cy="96" r="16" fill="#16ABB8" />
        <path
          d="M94 96l4 4 8-8"
          stroke="#fff"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p class="orders-empty-title">Замовлень поки немає</p>
      <p class="orders-empty-text">
        Тут зʼявляться ваші замовлення після першої покупки
      </p>
      <button
        class="orders-empty-cta"
        @click="$emit('setIsChangePage', 'home')"
      >
        Перейти до каталогу
      </button>
    </div>
  </div>
</template>

<script>
import { GET_ONE_PRODUCT } from "../resources/js/helpers/requests";

export default {
  name: "MyOrdersPage",
  props: {
    orders: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      openedOrderId: this.$store.getters.selectedOrderId ? Number(this.$store.getters.selectedOrderId) : null,
      busy: false,
      actionError: '',
      actionMessage: '',
    };
  },
  watch: {},
  methods: {
    setIsChangePage(page) {
      this.isShowPage = page;
    },
    toggleOrder(orderId) {
      this.openedOrderId = this.openedOrderId === orderId ? null : orderId;
    },
    filteredOrderItems(order) {
      return (order.items || []).filter((item) => item.product);
    },
    formatOrderDate(order) {
      if (order.success_at && typeof order.success_at === 'string') {
        return order.success_at.slice(0, 10).split('-').reverse().join('.');
      }
      if (order.new_at && typeof order.new_at === 'string') {
        return order.new_at.slice(0, 10).split('-').reverse().join('.');
      }
      return '';
    },
    async setAddproductToCart(item) {
      if (this.busy) return;
      this.busy = true; this.actionError = '';
      try {
        const result = await GET_ONE_PRODUCT(item.product.id);
        if (result.data?.available === false || Number(result.data?.qty) < 1) throw new Error('Товар зараз недоступний.');
        const added = await this.$store.dispatch('addProductFromDetails', { product: result.data, quantity: 1 });
        if (!added) throw new Error('Зачекайте, поки кошик оновиться.');
      } catch (error) { this.actionError = error.message === 'Товар зараз недоступний.' ? error.message : 'Не вдалося додати товар. Перевірте кошик перед повторною дією.'; }
      finally { this.busy = false; }
    },
    async repeatOrder(order) {
      if (this.busy) return;
      this.busy = true; this.actionError = ''; this.actionMessage = '';
      try {
        const result = await this.$store.dispatch('repeatOrder', order.id);
        if (!result) return;
        this.$store.commit('setUndoMessage', 'Замовлення повторено за актуальними цінами. Перевірте кількість: недоступні позиції пропущено.');
        this.$emit('setIsChangePage', 'cart');
      } catch (error) { this.actionError = error.details?.message || 'Не вдалося підтвердити повторення. Перевірте кошик перед повторною дією.'; }
      finally { this.busy = false; }
    },
    getCartTotal() {
      const cart = this.$store.getters.getCustomerCart;
      if (!cart || !cart.items) return 0;
      return cart.items.reduce((sum, item) => {
        return sum + item.price_item_total;
      }, 0);
    },
  },
  computed: {
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
  },
};
</script>

<style scoped>
.order-action-error { padding: 12px; color: #a12424; }
.order-link { display: inline-flex; min-height: 44px; align-items: center; color: #075a63; font-weight: 600; }
.repeat-order-btn:disabled { opacity: .5; }
.order-product-info { min-width: 0; overflow-wrap: anywhere; }

.my-orders-page {
  padding: 16px 8px 0 8px;
  background: #fff;
  min-height: 100vh;
}
.page-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}
.orders-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.orders-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  gap: 8px;
}
.orders-empty-illustration {
  margin-bottom: 12px;
}
.orders-empty-title {
  color: #333;
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
}
.orders-empty-text {
  color: #707070;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  max-width: 260px;
  margin-bottom: 12px;
}
.orders-empty-cta {
  padding: 14px 28px;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}
.orders-empty-cta:hover {
  background: #14a0ad;
}
.order-card {
  display: flex;
  background: #f8f8f8;
  border-radius: 16px;
  padding: 12px 14px;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: relative;
}
.order-images-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 18px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 4px;
  height: 88px;
  width: 88px;
}
.order-image {
  object-fit: cover;
  background: #fff;
}
.order-images-wrapper.images-count-1 .order-image {
  width: 80px;
  height: 80px;
}
.order-images-wrapper.images-count-2 .order-image {
  width: 40px;
  height: 40px;
}
.order-images-wrapper.images-count-3 .order-image,
.order-images-wrapper.images-count-4 .order-image {
  width: 36px;
  height: 36px;
}

.order-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.order-row {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  align-items: center;
}
.order-label {
  color: #b0b0b0;
  font-size: 14px;
  font-weight: 400;
}
.order-value {
  font-size: 14px;
  font-weight: 400;
}
.order-number,
.order-date,
.order-amount {
  color: #0096e6;
}
.order-details {
  color: #0096e6;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.arrow-down {
  font-size: 12px;
  margin-left: 4px;
}
.details-row {
  margin-top: 2px;
}
.order-products-list {
  margin-top: 12px;
  padding: 16px 18px;
  background: #f8f8f8;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.order-product {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f4faff;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}
.order-product-cart-btn {
  background: #00bcd4;
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  cursor: pointer;
  transition: background 0.2s;
  min-width: 40px;
}
.order-product-cart-btn:hover {
  background: #0096e6;
}
.order-product-cart-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.order-product-image {
  width: 72px;
  height: 72px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e0e0e0;
}
.order-product-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.order-product-name {
  font-size: 13px;
  font-weight: 500;
  color: #333333;
}
.order-product-code {
  font-size: 12px;
  font-weight: 400;
  color: #707070;
}
.order-product-wrapper {
  display: flex;
  gap: 5px;
}
.order-product-price {
  font-size: 13px;
  color: #01bace;
  font-weight: 600;
}
.order-product-qty {
  font-size: 13px;
  color: #01bace;
  font-weight: 600;
  opacity: 0.4;
}
.repeat-order-btn {
  width: 100%;
  padding: 12px 0;
  background: #fff;
  border: 2px solid #00bcd4;
  border-radius: 10px;
  color: #00bcd4;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.repeat-order-btn:hover {
  background: #00bcd4;
  color: #fff;
}
.repeat-order-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}
.order-total {
  display: flex;
  justify-content: space-around;
  font-weight: 500;
  font-size: 16px;
  color: #121212;
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  padding: 12px;
  border-radius: 4px;
}
.order-total-price {
  color: #01bace;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .my-orders-page {
    max-width: 1400px;
    margin: 0 auto;
    padding: 40px;
  }

  .page-title {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 40px;
    color: #1a1a1a;
  }

  .orders-list {
    gap: 32px;
  }

  .order-card {
    padding: 8px 10px;
    border-radius: 20px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .order-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }

  .order-images-wrapper {
    width: 140px;
    height: 140px;
    margin-right: 32px;
    border-radius: 12px;
  }

  .order-images-wrapper.images-count-1 .order-image {
    width: 130px;
    height: 130px;
  }

  .order-images-wrapper.images-count-2 .order-image {
    width: 65px;
    height: 65px;
  }

  .order-images-wrapper.images-count-3 .order-image,
  .order-images-wrapper.images-count-4 .order-image {
    width: 60px;
    height: 60px;
  }

  .order-info {
    gap: 12px;
  }

  .order-row {
    font-size: 18px;
  }

  .order-label {
    font-size: 16px;
    color: #707070;
  }

  .order-value {
    font-size: 16px;
    font-weight: 600;
  }

  .order-number,
  .order-date,
  .order-amount {
    font-size: 18px;
    font-weight: 700;
  }

  .order-details {
    font-size: 18px;
    font-weight: 600;
    margin-top: 8px;
    transition: all 0.2s ease;
  }

  .order-details:hover {
    color: #0096e6;
    transform: translateX(4px);
  }

  .order-products-list {
    margin-top: 20px;
    padding: 12px;
    border-radius: 20px;
    gap: 16px;
  }

  .order-product {
    padding: 8px 10px;
    gap: 16px;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .order-product:hover {
    background: #e8f4f8;
    transform: translateX(4px);
  }

  .order-product-image {
    width: 110px;
    height: 110px;
    border-radius: 12px;
  }

  .order-product-info {
    gap: 6px;
  }

  .order-product-name {
    font-size: 16px;
    font-weight: 600;
  }

  .order-product-code {
    font-size: 14px;
  }

  .order-product-price,
  .order-product-qty {
    font-size: 16px;
    font-weight: 700;
  }

  .order-product-cart-btn {
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 10px;
  }

  .order-product-cart-icon {
    width: 28px;
    height: 28px;
  }

  .repeat-order-btn {
    padding: 15px 0;
    font-size: 22px;
    font-weight: 600;
    border-radius: 14px;
    transition: all 0.3s ease;
  }

  .repeat-order-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 188, 212, 0.3);
  }

  .order-total {
    font-size: 20px;
    font-weight: 700;
    padding: 15px;
    border-radius: 12px;
  }

  .order-total-price {
    font-size: 24px;
  }

  .orders-empty-state {
    padding: 100px 20px;
  }
  .orders-empty-title {
    font-size: 26px;
  }
  .orders-empty-text {
    font-size: 16px;
    max-width: 340px;
  }
}
</style>
